/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Condition } from './Condition';
import {
    ConditionFromJSON,
    ConditionFromJSONTyped,
    ConditionToJSON,
} from './Condition';

/**
 * 
 * @export
 * @interface ControlNotCondition
 */
export interface ControlNotCondition {
    /**
     * 
     * @type {string}
     * @memberof ControlNotCondition
     */
    type?: string;
    /**
     * 
     * @type {Condition}
     * @memberof ControlNotCondition
     */
    condition: Condition;
}

/**
 * Check if a given object implements the ControlNotCondition interface.
 */
export function instanceOfControlNotCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "condition" in value;

    return isInstance;
}

export function ControlNotConditionFromJSON(json: any): ControlNotCondition {
    return ControlNotConditionFromJSONTyped(json, false);
}

export function ControlNotConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlNotCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'condition': ConditionFromJSON(json['condition']),
    };
}

export function ControlNotConditionToJSON(value?: ControlNotCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'condition': ConditionToJSON(value.condition),
    };
}

